module.exports = __webpack_public_path__ + "img/gift4-01-c07-t1.483b5dd4.png";